import React, { ComponentType } from 'react';
import { ShopColors } from '../util/colorPalettes';
import { useDefaultShopStyles } from '../hooks/useDefaultShopStyles';

export interface WithDefaultShopStylesProps {
  defaultShopStyles: ShopColors;
}

export function withDefaultShopStyles<P extends object>(
  Component: ComponentType<P & WithDefaultShopStylesProps>
) {
  const WithDefaultShopStylesComponent = (props: P) => {
    const defaultShopStyles = useDefaultShopStyles();

    return <Component {...props} defaultShopStyles={defaultShopStyles} />;
  };

  WithDefaultShopStylesComponent.displayName = `withDefaultShopStyles(${
    Component.displayName || Component.name
  })`;

  return WithDefaultShopStylesComponent;
}
